import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import "./EditButton.scss";

const EditButton = ({ onClick, text, undo }) => {
	const handleMouseDown = (e) => {
		e.stopPropagation();
	};

	return (
		<div
			onMouseDown={handleMouseDown}
			onClick={onClick}
			className="course-edit-button"
		>
			{text ? <p><span>{text}</span> <FontAwesomeIcon icon={faPenToSquare} /></p>
				:
				undo ? <p><span>Undo</span> <FontAwesomeIcon icon={faRotateLeft} /></p>
				:
					<p><span>Edit</span> <FontAwesomeIcon icon={faPenToSquare} /></p>
			}
			
		</div>
	);
};

export default EditButton;
